import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const deleteDepartmentStart = createAction(
  'DELETE_DEPARTMENT::START',
  withPayloadType<{ departmentId: string; organizationId: string }>(),
);
